<div
  class="relative flex flex-col min-h-screen pt-20 pb-40 lg:pb-20 xl:pb-40 px-5 lg:px-0 bg-neutral-800 font-base text-center text-white text-base leading-5.5 justify-center"
  [class.pt-6]="isNotched"
>
  <div class="lg:hidden">
    <div class="min-h-246px">
      <div class="mb-3">
        <app-faded-carousel-atom [items]="imageSlides"></app-faded-carousel-atom>
      </div>
      <div class="mb-3">
        <app-faded-carousel-atom [items]="textSlides"></app-faded-carousel-atom>
      </div>
      <p class="font-base">{{ leading }}</p>
    </div>
    <div class="flex justify-center mx-auto mt-10 mb-3 max-w-sm">
      <div
        *ngIf="distributionModeItems?.length > 1 && distributionModeItems?.length < 3"
        class="w-full mx-auto"
      >
        <app-parameters-distribution-mode-block
          [selectedDistributionMode]="selectedDistributionMode"
          [isCartParameters]="true"
          [items]="distributionModeItems"
          (selectItem)="distributionModeChanged($event)"
        ></app-parameters-distribution-mode-block>
      </div>
      <div
        *ngIf="distributionModeItems?.length >= 3"
        class="w-full mx-auto text-neutral-800"
      >
        <app-custom-select-atom
          [items]="distributionModeItems"
          [selectedItem]="selectedDistributionMode"
          (selectItem)="distributionModeChanged($event)"
        ></app-custom-select-atom>
      </div>
    </div>
    <div class="mb-3.5 max-w-sm mx-auto">
      <app-input-text-atom
        [label]="'parameters.location-placeholder' | translate"
        [iconRight]="'icon-position'"
        [buttonLabel]="'Go'"
        [value]="selectedAddress?.address"
        [cross]="true"
        (enterPress)="goToSearchPage()"
        (buttonClick)="goToSearchPage()"
        (iconClick)="geolocalizeUser()"
        (valueChange)="resetValue()"
      ></app-input-text-atom>
    </div>
  </div>

  <div class="hidden lg:flex flex-row flex-grow items-center px-32 xl:px-40 font-accent">
    <div
      class="pr-14 xl:pr-32 3xl:pr-40"
      [ngClass]="containerDevided ? 'w-6/12' : 'w-8/12'"
    >
      <h1 class="pb-7 font-bold text-5.7xl leading-13 text-left">
        {{ heading }}
      </h1>
      <p class="mb-16 font-base text-3xs text-left">{{ leading }}</p>
      <div class="flex justify-center mb-3 max-w-sm">
        <div
          *ngIf="distributionModeItems?.length > 1 && distributionModeItems?.length < 3"
          class="w-full mx-auto"
        >
          <app-parameters-distribution-mode-block
            [selectedDistributionMode]="selectedDistributionMode"
            [isCartParameters]="true"
            [items]="distributionModeItems"
            (selectItem)="distributionModeChanged($event)"
          ></app-parameters-distribution-mode-block>
        </div>
        <div
          *ngIf="distributionModeItems?.length >= 3"
          class="w-full mx-auto text-neutral-800"
        >
          <app-custom-select-atom
            [items]="distributionModeItems"
            [selectedItem]="selectedDistributionMode"
            (selectItem)="distributionModeChanged($event)"
          ></app-custom-select-atom>
        </div>
      </div>
      <div class="mb-4 max-w-sm">
        <app-input-text-atom
          [label]="'parameters.location-placeholder' | translate"
          [iconRight]="'icon-position'"
          [buttonLabel]="'Go'"
          [value]="selectedAddress?.address"
          [cross]="true"
          (enterPress)="goToSearchPage()"
          (buttonClick)="goToSearchPage()"
          (iconClick)="geolocalizeUser()"
          (valueChange)="resetValue()"
        ></app-input-text-atom>
        <div
          *ngIf="geolocalizeError?.length"
          class="py-6 text-white font-base text-sm"
        >
          {{ geolocalizeError }}
        </div>
      </div>
    </div>
    <div [ngClass]="containerDevided ? 'w-6/12' : 'w-4/12'">
      <app-faded-carousel-atom [items]="imageSlides"></app-faded-carousel-atom>
    </div>
  </div>
  <div class="absolute right-0 left-0 bottom-5">
    <a (click)="scrollTo()"><i class="icon icon-chevron-down cursor-pointer text-white"></i></a>
  </div>
</div>
<div id="bottom-dood-hero"></div>
